export const GetCourseData = async (crsnum) => {
    let returnData = {};
    return fetch(`api/general/GetCourseName/${crsnum}`)
        .then(this.handleResponse)

        .then(response => response.json())
         
  
}
export const GetCourseSchedule = async (crsnum) => {
     return fetch(`api/class/OverViewTab/${crsnum}`)
        .then(handleResponse)

        .then(response => response.json())
         
  
}
const handleResponse = (response) => {

    if (!response.ok) {
        if (response.status === 401) {
            // auto logout if 401 response returned from api
            console.log(this.props)
            window.location = "http://www.google.com"
        }


        return Promise.reject();
    }
    return Promise.resolve(response)


}
export const GetBookPages = async (crsnum) => {
    let returnData = {};
    return fetch(`api/general/GetBookPages/${crsnum}`)
        .then(this.handleResponse)

        .then(response => response.text())
         
  
}


// WEBPACK FOOTER //
// ./src/pages/course/API.js